/* block */
(function() { 
    const urlParams = new URLSearchParams(window.location.search);
    const directCheckout = urlParams.get('direct-checkout');
    if (directCheckout === 'true') {
        processAutoCheckout();
    }
    function processAutoCheckout() {
        const urlParams = new URLSearchParams(window.location.search);
        let variantId = urlParams.get('variant');
        let quantity = urlParams.get('quantity') || '1';
        if (!variantId) {
            if (typeof window.product !== 'undefined' && window.product && window.product.variants && window.product.variants.length > 0) {
                variantId = window.product.variants[0].id;
            }
            else {
                const variantSelect = document.querySelector('[name="id"], [name="variant"], select[name*="variant"]');
                const variantInput = document.querySelector('input[name="id"], input[name="variant"]');
                if (variantSelect && variantSelect.value) {
                    variantId = variantSelect.value;
                } else if (variantInput && variantInput.value) {
                    variantId = variantInput.value;
                }
            }
        }
        if (!variantId) {
            console.error('[DirectCheckout] Could not determine product variant for auto-checkout');
            return;
        }
        document.body.style.opacity = '0.1';
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
            .then(response => {
                return response.json();
            })
            .then(data => {
                window.location.href = window.Shopify.routes.root + 'checkout';
            })
            .catch(error => {
                console.error('[DirectCheckout] Error adding to cart:', error);
                document.body.style.opacity = '1';
            });
    }
})();
